import { GAMEPLAY_CONFIG } from '../../app/config';

export type GameplaySnapshot = {
  lives: number;
  maxLives: number;
  ammo: number;
  maxAmmo: number;
};

export type LifePickupResult = {
  restored: boolean;
  scoreCompensation: number;
};

export class GameplaySession {
  private livesValue: number = GAMEPLAY_CONFIG.player.initialLives;
  private ammoValue: number = GAMEPLAY_CONFIG.weapon.initialAmmo;

  public get snapshot(): GameplaySnapshot {
    return {
      lives: this.livesValue,
      maxLives: GAMEPLAY_CONFIG.player.maxLives,
      ammo: this.ammoValue,
      maxAmmo: GAMEPLAY_CONFIG.weapon.maxAmmo,
    };
  }

  public reset(): void {
    this.livesValue = GAMEPLAY_CONFIG.player.initialLives;
    this.ammoValue = GAMEPLAY_CONFIG.weapon.initialAmmo;
  }

  public consumeShot(): boolean {
    if (this.ammoValue < GAMEPLAY_CONFIG.weapon.shotCost) return false;
    this.ammoValue = Math.max(0, this.ammoValue - GAMEPLAY_CONFIG.weapon.shotCost);
    return true;
  }

  public addAmmo(amount = GAMEPLAY_CONFIG.powerUps.ammo.value): number {
    const before = this.ammoValue;
    this.ammoValue = Math.min(GAMEPLAY_CONFIG.weapon.maxAmmo, this.ammoValue + Math.max(0, amount));
    return this.ammoValue - before;
  }

  public takeDamage(): boolean {
    if (this.livesValue <= 0) return false;
    this.livesValue -= 1;
    return true;
  }

  public addLife(): LifePickupResult {
    if (this.livesValue >= GAMEPLAY_CONFIG.player.maxLives) {
      return {
        restored: false,
        scoreCompensation: GAMEPLAY_CONFIG.powerUps.life.fullLivesScoreCompensation,
      };
    }
    this.livesValue = Math.min(
      GAMEPLAY_CONFIG.player.maxLives,
      this.livesValue + GAMEPLAY_CONFIG.powerUps.life.value,
    );
    return { restored: true, scoreCompensation: 0 };
  }

  public setLivesForTest(lives: number): void {
    this.livesValue = Math.min(GAMEPLAY_CONFIG.player.maxLives, Math.max(0, Math.floor(lives)));
  }

  public setAmmoForTest(ammo: number): void {
    this.ammoValue = Math.min(GAMEPLAY_CONFIG.weapon.maxAmmo, Math.max(0, Math.floor(ammo)));
  }
}
